import React, { useState, useEffect } from "react";

interface IProps {
  type: "radio" | "checkbox";
  label: string;
  name?: string;
  value?: string;
  checked: boolean;
  onChange(cheked: boolean): void;
}

const AppFormCheck = (props: IProps) => {
  const [check, setCheck] = useState(props.checked);

  const { checked } = props;

  useEffect(() => {
    setCheck(checked);
  }, [checked]);

  return (
    <div className="form-check">
      <input
        type={props.type}
        checked={check}
        className="form-check-input"
        value={props.value}
        name={props.name}
        onChange={(e: any) => {
          setCheck(e.target.checked);
          props.onChange(e.target.checked);
        }}
      />
      <label
        className="form-check-label"
        onClick={(e: any) => {
          if (props.type === "checkbox") {
            props.onChange(!check);
            setCheck(!check);
          } else {
            props.onChange(!check);
            setCheck(check);
          }
        }}
      >
        {props.label}
      </label>
    </div>
  );
};

export default AppFormCheck;
